<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { resolveLogosStyling } from './_utils/resolveLogosStyling';
    import LogosView from './Logos.View.svelte';

    import type { LogosContent } from '$lib/types/Components/Logos/LogosContent';
    import type { Box as BoxType } from '$lib/types/Components/SharedTypes';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let theme: Theme;
    export let content: LogosContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;

    const styling = resolveLogosStyling({ theme });

    // When brand paddingX/paddingY is set, it replaces the per-block box padding on the
    // matching axis (mirrors editor's `Logos/Component.tsx` newBox memo).
    const effectiveBox = {
        ...content.box,
        ...(theme.paddingX ? { left: 'none', right: 'none' } : {}),
        ...(theme.paddingY ? { top: 'none', bottom: 'none' } : {}),
    } as BoxType;
</script>

<LogosView
    {id}
    box={effectiveBox}
    images={content.images}
    isGrayscale={content.isGrayscale}
    size={content.size}
    logoGapXPx={styling.logoGapXPx}
    paddingClass={styling.paddingClass}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
